export class ResourceType {
    public ResourceTypeId: number = -1;
    public Name: string = "";
    public Branch: number = -1;
    public SafetyPolicy: number = -1;
    public Active: boolean = true;
    public UseQueueManager: boolean = false;
    public PaymentAfterSession: boolean = false;

    public static CreateFrom(r: any): ResourceType {
        if (!r)
            return null;
        var resourceType: ResourceType = new ResourceType();
        resourceType.Name = r.Name;
        resourceType.ResourceTypeId = r.ResourceTypeId;
        resourceType.Active = r.Active;
        resourceType.UseQueueManager = r.UseQueueManager;
        resourceType.Branch = r.Branch;
        resourceType.SafetyPolicy = r.SafetyPolicy;
        resourceType.PaymentAfterSession = r.PaymentAfterSession;
        return resourceType;
    }

    constructor() {
    }
};